module.exports = __webpack_public_path__ + "static/media/logo-wecycle-solo.3622f4a3.png";